// @flow weak

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { DropdownMenuWrapper } from 'web-ssr/app/common/components/DropdownMenu';

const DropdownStateful = createReactClass({
  displayName: 'DropdownStateful',

  propTypes: {
    items: PropTypes.array,
    renderMenu: PropTypes.func.isRequired,
    renderToggle: PropTypes.func.isRequired,
    onChoose: PropTypes.func,
    onOpen: PropTypes.func,
  },

  getInitialState() {
    return { isOpen: false };
  },

  close() {
    this.setState({ isOpen: false });
  },

  onChoose(value, didConfirm, item) {
    if (didConfirm) {
      this.close();
    }
    if (this.props.onChoose) {
      this.props.onChoose(value, didConfirm, item);
    }
  },

  onClickToggler() {
    if (!this.state.isOpen && this.props.onOpen) {
      this.props.onOpen();
    }
    this.setState({ isOpen: !this.state.isOpen });
  },

  onClickOutside() {
    this.close();
  },

  render() {
    const { props } = this;
    const menu = !this.state.isOpen
      ? null
      : props.renderMenu({
          items: this.props.items,
          onChoose: this.onChoose,
          onClickOutside: this.onClickOutside,
        });
    const toggle = props.renderToggle({
      onClick: this.onClickToggler,
    });
    return (
      <DropdownMenuWrapper {...this.props}>
        {toggle}
        {menu}
      </DropdownMenuWrapper>
    );
  },
});

export default DropdownStateful;
